import { useState, useEffect, useCallback } from "react";
import { logger } from "../utils/logger";

export const useUser = () => {
    // Funzione centralizzata per leggere lo stato utente dal localStorage
    const getUserFromStorage = useCallback(() => {
        try {
            const sessionString = localStorage.getItem("ApolloSession");
            if (!sessionString) return null;

            const sessions = JSON.parse(sessionString);

            if (Array.isArray(sessions)) {
                // Cerca una sessione attiva
                const activeSession = sessions.find(session => session.active);

                // Se non trova sessioni attive, usa la prima disponibile
                return activeSession || sessions[0] || null;
            }
            return null;
        } catch (e) {
            logger.error("Errore nel parsing della sessione:", e);
            return null;
        }
    }, []);
    // Stato iniziale basato sul localStorage
    const [user, setUser] = useState(getUserFromStorage);

    // Funzione di aggiornamento esposta
    const updateUser = useCallback(() => {
        const newUser = getUserFromStorage();
        logger.log("Aggiornamento utente da localStorage:", newUser);
        setUser(newUser);
    }, [getUserFromStorage]);

    // Aggiorna l'utente quando cambia la sessione
    useEffect(() => {
        const handleStorageChange = () => {
            // Aggiorna solo se la chiave modificata è quella della sessione
            updateUser();
        };

        const handleLoginEvent = () => {
            logger.log("Evento userLoggedIn ricevuto");
            updateUser();
        };

        const handleLogoutEvent = () => {
            logger.log("Evento userLoggedOut ricevuto");
            setUser(null);
        };

        // Registra gli eventi
        window.addEventListener("storage", handleStorageChange);
        window.addEventListener("userLoggedIn", handleLoginEvent);
        window.addEventListener("userLoggedOut", handleLogoutEvent);

        // Cleanup
        return () => {
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("userLoggedIn", handleLoginEvent);
            window.removeEventListener("userLoggedOut", handleLogoutEvent);
        };
    }, [updateUser]);

    // Effetto per gestire sincronizzazione tra tab
    useEffect(() => {
        // Forza l'aggiornamento quando la tab diventa visibile
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                updateUser();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [updateUser]);

    return {
        user,
        updateUser,
        isAuthenticated: !!user,
        userType: user?.type || null,
        userId: user?.id || null
    };
};
